import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async"; // Exposes thread-safe header mutations
import "@/index.css";
import App from "@/App";

if ("serviceWorker" in navigator) {
  const swUrl = "/service-worker.js";
  navigator.serviceWorker.register(swUrl).catch((err) => {
    console.warn("Service worker registration failed:", err);
  });
}

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  // Hydrate the pre-rendered HTML generated by react-snap
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider> {/* Wraps production build target injection paths */}
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  // Fallback to standard client-side rendering for local development
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider> {/* Wraps isolated local development runtime instances */}
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}